import { MwPayloadModel } from 'app/models/payload.model';
import * as vehicleTypesActions from '../actions/vehicle-types.actions';
import { VehicleTypeModel } from 'app/models/vehicle-types-api.model';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  vehicleTypes: VehicleTypeModel[];
  totalVehicleTypes: number;
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  vehicleTypes: [],
  totalVehicleTypes: 0,
  isLoading: false,
  isReady: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(vehicleTypesActions.loadVehicleTypes, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(
    vehicleTypesActions.loadVehicleTypesSuccess,
    (state: State, { response }) => ({
      ...state,
      vehicleTypes: response.results.map((vehicleType) =>
        VehicleTypeModel.map(vehicleType)
      ),
      totalVehicleTypes: response.count,
      isLoading: false,
      isReady: true,
    })
  ),
  on(
    vehicleTypesActions.createVehicleType,
    vehicleTypesActions.updateVehicleType,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    vehicleTypesActions.createVehicleTypeSuccess,
    vehicleTypesActions.createVehicleTypeFailed,
    vehicleTypesActions.updateVehicleTypeSuccess,
    vehicleTypesActions.updateVehicleTypeFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    vehicleTypesActions.resetVehicleTypes,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
